<template>
    <b-modal 
      id="icdl-survey-modal"
      size="xl"
      centered 
      title="Votre certificat est en cours de création." 
      title-class="text-center w-100"
      header-bg-variant="primary" 
      header-text-variant="light"
      body-class="pb-4"
      :hide-footer="true"
    >
    <template #modal-header>
      <b-container class="text-center">
        <b-row>
            <b-col>
                <h5>Votre certificat est en cours de création.</h5>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <h5 class="mb-0">En attendant, merci de nous donner votre avis.</h5>
            </b-col>
        </b-row>
      </b-container>
      <button type="button" aria-label="Close" class="close text-light m-auto position-absolute" style="right:8px;" @click="$bvModal.hide('icdl-survey-modal')">×</button>
    </template>

      <b-container class="mt-3">
        <b-row class="pb-3">
          <b-col></b-col>
          <b-col cols="9">
            <div class="bg-primary px-5 py-4 align-center text-center text-white font-weight-bold w-100" style="border-radius:20px">
              <b-carousel
                v-if="renderComponent"
                id="loading-result-survey"
                ref="surveyCarousel"
                :class="' '+ displayedSlideClass"
                :interval="0"
                :controls="icdlSurvey.length>1"
                :indicators="icdlSurvey.length>1"
                background="#A3DCF3"
                style="border-radius:20px !important;"
                img-height="370"
                no-wrap
                @sliding-end="onSlideEnd"
                :value="displayedSlideIndex"
              >
                <template v-for="q in icdlSurvey">
                <b-carousel-slide v-if="!q.alreadyAnswered && icdlSurveyToDisplay.includes(q.id)" :key='q.id'>
                  <b-form-group :label="q.title" label-size="lg" class="text-dark mt-2 ml-2 mr-2 pb-2">
                    <template v-if="q.type=='radio'">
                      <b-form-radio-group :name="''+q.id" v-model="q.checked" stacked @change="updateRadio(q, $event)">
                        <template v-for="p in q.proposals">
                          <div :key="'proposal-'+p.id" class="proposal mt-1 mb-1 d-flex align-items-center font-weight-normal">
                            <b-form-radio :key="'radio-'+p.id" :name="''+q.id" :value="p.id" class="mr-1" :checked="p.id==1">{{ p.title }}</b-form-radio>
                            <b-form-input v-if="p.free_field==true" placeholder="Veuillez préciser" :key="'input-'+p.id" :disabled="p.id != q.checked" v-model="p.freeFieldValue" class="additional-response ml-1 w-auto" @blur="updateFreeField(q, p.id, p.freeFieldValue)" style="height:1.4rem"></b-form-input>
                          </div>
                        </template>
                      </b-form-radio-group>
                    </template>
                    <template v-else-if="q.type=='checkbox'">
                      <b-form-checkbox-group :name="''+q.id" class="text-dark" stacked v-model="q.checked">
                        <template v-for="p in q.proposals">
                          <div v-if="q.id!=47" :key="'div-'+p.id" class="proposal mt-1 mb-1 d-flex align-items-center font-weight-normal">
                            <b-form-checkbox :key="'checkbox-'+p.id" :value="p.id" @change="updateCheckbox(q, p)">{{ p.title }}</b-form-checkbox>
                            <b-form-input v-if="p.free_field==true" placeholder="Veuillez préciser" :disabled="!q.checked.includes(p.id)" v-model="p.freeFieldValue" :key="'input-'+p.id" class="additional-response ml-1 w-auto" @blur="updateFreeField(q, p, p.freeFieldValue)" style="height:1.4rem"></b-form-input>
                          </div>
                          <div v-else :key="'div-'+p.id" class="proposal mt-1 mb-3 d-flex align-items-center font-weight-normal">
                            <b-form-input v-if="p.free_field==true" :placeholder="p.title" v-model="p.freeFieldValue" :key="'input-'+p.id" maxlength="30" class="additional-response ml-1 w-auto" @blur="updateFreeField(q, p, p.freeFieldValue)"></b-form-input>
                          </div>
                        </template>
                      </b-form-checkbox-group>
                    </template>
                    <template v-else-if="q.type=='text'">
                        <template v-for="p in q.proposals">
                          <b-form-textarea :key="'input-'+p.id" :placeholder="p.title" v-model="p.value" maxlength="255" rows="5" class="text-dark w-100" @blur="updateText(p)"></b-form-textarea>
                        </template>
                    </template>
                  </b-form-group>
                </b-carousel-slide>
                </template>
                <b-carousel-slide>
                  <b-form-group label="Merci pour votre contribution." label-size="lg" class="text-dark text-center mt-2 ml-2 mr-2 pb-2"></b-form-group>
                </b-carousel-slide>
              </b-carousel>
            </div>
          </b-col>
          <b-col></b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col></b-col>
          <b-col cols="4">
            <b-button v-if="certificateOnLoading" id="loading-result-btn" class="w-100 pt-3" variant="secondary">
              <b-icon-arrow-repeat animation="spin" scale="2"></b-icon-arrow-repeat>
              <p class="mt-2 mb-1 text-uppercase">Création du certificat</p>
            </b-button>

            <b-button
              v-else
              id="access-result-btn" 
              class="w-100 pt-3" 
              variant="secondary" 
              @click="$bvModal.hide('icdl-survey-modal')"
              :to="{name: 'Certificate', params: { user: $parent.userId }}" 
              target="_blank" 
            >
              <b-icon-check-circle scale="2"></b-icon-check-circle>
              <p class="mt-2 mb-1 text-uppercase">Accéder à mon certificat</p>
            </b-button>
          </b-col>
          <b-col></b-col>
        </b-row>

      </b-container>

    </b-modal>
</template>

<script>

import surveyApi from '@/services/survey.js'

export default {
  data () {
    return {
        name: 'IcdlSurvey',
        icdlSurvey: [],
        displayedSlideClass: "on-first-slide",
        loadTimer: 0,
        certificateOnLoading : true,
        loadingStarted: false,
        textTimer: null,
        freeFieldTimer: null,
        renderComponent: true,
        displayedSlideIndex: 0
    }
  },
  computed: {
    icdlSurveyToDisplay() {return this.$parent.icdlSurveyToDisplay},
    loadedIcdlSurvey() {return this.$parent.loadedIcdlSurvey},
  },
  methods: {
      nextSlide() {
        this.$refs.surveyCarousel.next()
      },
      onSlideEnd() {
        this.displayedSlideIndex = this.$refs.surveyCarousel.index
        if (this.$refs.surveyCarousel.index == 0) {
          this.displayedSlideClass = "on-first-slide"
        }
        else if (this.$refs.surveyCarousel.index == this.icdlSurveyToDisplay.length) {
          this.displayedSlideClass = "on-last-slide"
        }
        else {
          this.displayedSlideClass = ""
        }
      },
      async initTimer() {
        window.clearTimeout(this.loadTimer);
        this.loadingStarted=true
        this.loadTimer = await window.setTimeout(() => {
          this.certificateOnLoading = false
        }, 20000)
      },
      showModal() {
        this.$bvModal.show('icdl-survey-modal')
      },
      async updateRadio(survey, idProposal, freeField='') {
        await this.$nextTick(() => {
          this.forceRender()
          this.$parent.updateSurveyToDisplay("icdl")
          survey.proposals.forEach(prop => {
            if (prop.id!=idProposal && prop.free_field==true) {
              prop.freeFieldValue=""
            }
          })
          let proposal = survey.proposals.find(prop => prop.id==idProposal)
          if (proposal.free_field != true) {
            this.nextSlide();
          }
          let obj= {};
          obj.freeField = freeField;
          surveyApi.post('response/new/'+proposal.id, obj).then(() => {})
        })
      },
      async updateCheckbox(survey, proposal, freeField="") {
        await this.$nextTick(() => {
          this.forceRender()
          this.$parent.updateSurveyToDisplay("icdl")
          let obj= {};
          if (survey.checked.includes(proposal.id)) {
            obj.freeField = freeField;
            surveyApi.post('response/new/'+proposal.id, obj).then(() => {})
          }
          else {
            if(proposal.free_field==true) {
              proposal.freeFieldValue = ""
            }
            surveyApi.delete('response/delete/'+proposal.id).then(() => {})
          }
        })
      },
      async updateText(proposal) {
        let obj= {};
        obj.freeField = proposal.value;
        surveyApi.post('response/new/'+proposal.id, obj).then({})
      },
      async updateFreeField(survey, proposal, freeFieldValue="") {
        if(survey.type=="radio") {
          this.updateRadio(survey, proposal, freeFieldValue)
        }
        if(survey.type=="checkbox") {
          if(survey.id==47) {
            if(freeFieldValue=="") {
              survey.checked.splice(survey.checked.indexOf(proposal.id))
            }
            else {
              survey.checked.push(proposal.id)
            }
          }
          this.updateCheckbox(survey, proposal, freeFieldValue)
        }
      },
      forceRender() {
        this.renderComponent= false
        this.renderComponent= true
      }
  },
  mounted() {
    if(this.loadedIcdlSurvey==true) {
        this.icdlSurvey = this.$parent.icdlSurvey;
    }
    this.$root.$on('bv::modal::show', () => {
      if(this.loadingStarted==false) {
        this.initTimer()
      }
    })
  },
  watch: {
    loadedIcdlSurvey() {
      if(this.loadedIcdlSurvey==true) {
        this.icdlSurvey = this.$parent.icdlSurvey;
      }
    }
  }
}
</script>

<style>
#loading-result-survey .carousel-item {
  height: 340px;
  text-align: left;
  border-radius: 20px !important;
}
#loading-result-survey .carousel-caption {
  height: 90%;
  padding-top: 0px;
  padding-bottom: 15px;
  text-align: left;
}
.additional-response{
  height:1rem
}

#loading-result-survey .carousel-caption {
  width: 90%;
  left: 5%;
  right: 5%;
}

#loading-result-survey .carousel-inner {
  border-radius: 20px !important;
}

#loading-result-survey .carousel-control-prev, #loading-result-survey .carousel-control-next {
  width:0px
}

.on-first-slide .carousel-control-prev {
  display: none;
}

.on-last-slide .carousel-control-next {
  display: none;
}

#loading-result-survey .carousel-control-prev-icon {
  position: absolute;
  left: -35px;
}
#loading-result-survey .carousel-control-next-icon {
  position: absolute;
  right: -35px;
}

#loading-result-btn, #access-result-btn {
  border-radius: 20px !important;
}
#loading-result-btn {
  cursor: wait;
}
</style>